import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// global pixel style
import { Style } from '@article/pixel';
// eslint-disable-next-line
const style: any = Style;
// override pixel style
import '@/assets/styles/main.scss';
// sentry integration
import * as Sentry from '@sentry/browser';

const app = createApp(App);

const sentryEnabled: boolean =
  (process.env.VUE_APP_SENTRY_ENABLED || '').trim().toLowerCase() === 'true';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENV,
  enabled: sentryEnabled,
});
app.config.errorHandler = error => {
  Sentry.captureException(error);
};

app.use(router).mount('#app');
